<template>
  <div class="page-title-wrapper">
    <div class="page-title">
      <slot name="title"></slot>
    </div>
    <div class="page-desc" v-if="$slots.desc">
      <slot name="desc"></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
.page-title-wrapper {
  padding: 6px 30px 0;

  .page-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    line-height: 33px;
  }
  .page-desc {
    margin-top: 8px;
    font-size: 14px;
    color: #999;
    line-height: 20px;
  }
}
</style>
